import { NgModule } from '@angular/core';
import { PlanCompensatorioComponent } from './plan-compensatorio.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { PlanCompensatorioRouting } from './plan-compensatorio-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { GuardarCompensacionComponent } from './guardar-compensaciones/guardar-compensaciones.component';
import { InformacionCompensatorioComponent } from './informacion-compensatorio/informacion-compensatorio.component';
import { InformacionInscripcionComponent } from './informacion-inscripcion/informacion-inscripcion.component';
import { InformacionTurnoComponent } from './informacion-turno/informacion-turno.component';
import { InscripcionCompensacionComponent } from './inscripcion-compensacion/inscripcion-compensacion.component';
import { AprobacionInscripcionCompensacionComponent } from './aprobacion-inscripcion-compensacion/aprobacion-inscripcion-compensacion.component';
import { ListaCompensacionDependenciaComponent } from './lista-compensacion-dependencia/lista-compensacion-dependencia.component';
import { SolicitudAjusteCompensacionComponent } from './solicitud-ajuste-compensacion/solicitud-ajuste-compensacion.component';
import { ModalSolicitudAjusteCompensacion } from './modal-solicitud-ajuste-compensacion/modal-solicitud-ajuste-compensacion.component';
import { ModalAprobacionAjusteCompensacion } from './modal-aprobacion-ajuste-compensacion/modal-aprobacion-ajuste-compensacion.component';
import { AprobacionAjusteCompensacionComponent } from './aprobacion-ajuste-compensacion/aprobacion-ajuste-compensacion.component';
import { ListaAjusteDependenciaComponent } from './lista-ajuste-dependencia/lista-ajuste-dependencia.component';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}
@NgModule({
    declarations: [
        PlanCompensatorioComponent,
        GuardarCompensacionComponent,
        InformacionCompensatorioComponent,
        InformacionInscripcionComponent,
        InformacionTurnoComponent,
        InscripcionCompensacionComponent,
        ListaCompensacionDependenciaComponent,
        AprobacionInscripcionCompensacionComponent,
        SolicitudAjusteCompensacionComponent,
        ModalSolicitudAjusteCompensacion,
        ListaAjusteDependenciaComponent,
        AprobacionAjusteCompensacionComponent,
        ModalAprobacionAjusteCompensacion
    ],
    exports: [ AprobacionAjusteCompensacionComponent ],
    imports: [
        PlanCompensatorioRouting,
        SharedModule,
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            isolate: true
        })
    ],
    entryComponents: [
        ModalSolicitudAjusteCompensacion,
        ModalAprobacionAjusteCompensacion
    ]
})
export class PlanCompensatorioModule { }
